import React, { useEffect, useState } from 'react'
import { Circle, Group, Transformer } from 'react-konva'
import { Html } from 'react-konva-utils';
import { createTheme } from '@mui/material/styles';
import { Box, Button, Grid, Icon, IconButton, ThemeProvider } from '@mui/material';

import ImportarImagen from '../../Functions/ImportarImagen';
import ModalImagen from '../Alertas/ModalImagen';
import SeleccionarColor from '../../Functions/SeleccionarColor';
import CambiarColorTexto from '../../Functions/CambiarColorTexto';

import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import HideImageIcon from '@mui/icons-material/HideImage';
import DeleteIcon from '@mui/icons-material/Delete';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';
import TextDecreaseIcon from '@mui/icons-material/TextDecrease';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';

import {
    CircleMenu,
    CircleMenuItem,
    TooltipPlacement,
  } from "react-circular-menu";


const PanelHerramientas = (props) => {

    const {
        x, y, id, width, height,
        mostrarImagen,
        setMostrarImagen,
        trRef,
        nodos,
        setNodos,
        lineas,
        setLineas,
        isSelected,
        textFill,
        fill,
        tieneImagen,
        align
    } = props;

    const theme = createTheme({
        palette: {
          primary: {
            light: "#F22E52",
            main: "#39aa28",
            dark: "#408036",
            contrastText: "#fff",
          },
          secondary: {
            light: "#ffffff",
            main: "#B3223C",
            dark: "#cccccc",
            contrastText: "#ff802e",
          },
          default: {
            light: "#ffffff",
            main: "#ffffff",
            dark: "#cccccc",
            contrastText: "#ff802e",
      
          }
        },
      });

    useEffect(() => {
        // action on update of movies
    }, [nodos]);

    const [abrirModalImagen, setAbrirModalImagen] = useState(false);
    const handleCloseModalImage = () => setAbrirModalImagen(false);

    const [abrirModalColor, setAbrirModalColor] = useState(false);
    const handleCloseColor = () => setAbrirModalColor(false);

    const [abrirModalTexto, setAbrirModalTexto] = useState(false);
    const handleCloseTexto = () => setAbrirModalTexto (false);


    const handleDelete = (e) =>{
        let pos = 0;

        nodos.map((nodo)=>{
            if(nodo.id === id){
                nodos.splice(pos, 1);
                setNodos(nodos);
            }
            pos++;
        })

        pos=0;
        const lineasAux = [];
        lineas.forEach( (linea) => {
            if(linea.rectangulosLinea.includes(id)){
            }else{
                lineasAux.push(linea);
            }
            pos++;
        })
        setLineas(lineasAux);
    }

    const handleImage = (e) =>{
        const idObjeto = id;
        setNodos(
            nodos.map( (nodo)=>{
                
                if(isSelected){

                    if(idObjeto === nodo.id){
                        if(nodo.tieneImagen === true){
                            return {
                                ...nodo,
                                urlImagen: '',
                                isDragging: false,
                                tieneImagen: false,
                            }
                        }
                    }
                    
                    else{
                        return {
                            ...nodo,
                            isDragging: false,
                        }
                    }
                }
                else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })

        )
    }

    const handleAlign = () =>{
        const idObjeto = id;
        setNodos(
            nodos.map( (nodo)=>{
                if(isSelected){
                    if(idObjeto === nodo.id){
                        if(nodo.align === 'center'){
                            return {
                                ...nodo,
                                align: 'right',
                                isDragging: false,
                            }
                        } 
                        if(nodo.align === 'right'){
                            return {
                                ...nodo,
                                align: 'left',
                                isDragging: false,
                            }
                        } 
                        if(nodo.align === 'left'){
                            return {
                                ...nodo,
                                align: 'center',
                                isDragging: false,
                            }
                        } 
                    }
                    
                    else{
                        return {
                            ...nodo,
                            isDragging: false,
                        }
                    }
                }
                else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })
        )
    }

    const increaseFont = () =>{
        const idObjeto = id;
        setNodos(
            nodos.map( (nodo)=>{
                if(isSelected){
                    if(idObjeto === nodo.id){
                        return {
                            ...nodo,
                            fontSize: nodo.fontSize+1,
                            isDragging: false,
                        }
                        
                    }
                    
                    else{
                        return {
                            ...nodo,
                            isDragging: false,
                        }
                    }
                }
                else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })
        )
    }
    
    const decreaseFont = () => {
        const idObjeto = id;
        setNodos(
            nodos.map( (nodo)=>{
                if(isSelected){
                    if(idObjeto === nodo.id && nodo.fontSize > 1){
                        return {
                            ...nodo,
                            fontSize: nodo.fontSize-1,
                            isDragging: false,
                        }
                        
                    }
                    
                    else{
                        return {
                            ...nodo,
                            isDragging: false,
                        }
                    }
                }
                else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })
        )
    }

    const handleTextColor = () =>{
        setAbrirModalTexto(!abrirModalTexto)
    }

    const handleNodeColor = () =>{
        setAbrirModalColor(!abrirModalColor);
    }

    return (
        <>
            <Transformer
                ref={trRef}
                rotateEnabled={false}
                centeredScaling={true}
                boundBoxFunc={(oldBox, newBox) => {
                    if (newBox.width < 5 || newBox.height < 5) {
                        return oldBox;
                    }
                    return newBox;
                }}
            />
            <Group x={x+width+40} y={y+height/2-18} >
                <Html divProps={{ style: { opacity: 1 } }}>
                    <ThemeProvider theme={theme}>

                    <CircleMenu
                        startAngle={-90}
                        rotationAngle={180}
                        itemSize={0.8}
                        radius={5}
                        >
                        { !tieneImagen ? 
                        (
                            <CircleMenuItem onClick={()=>{setAbrirModalImagen(!abrirModalImagen)}}>
                                <InsertPhotoIcon color='primary' fontSize='small'/>
                            </CircleMenuItem>
                        ):
                        (
                            <CircleMenuItem onClick={handleImage}>
                                <HideImageIcon color='primary' fontSize='small'/>
                            </CircleMenuItem>
                        )
                        }
                        <CircleMenuItem onClick={handleNodeColor}>
                                <ColorLensIcon color='primary' fontSize='small'/>
                        </CircleMenuItem>

                        <CircleMenuItem onClick={handleDelete}>
                            <DeleteIcon color='error' fontSize='small' />
                        </CircleMenuItem>

                        <CircleMenuItem onClick={handleTextColor}>
                            <FormatColorTextIcon color='primary' fontSize='small'/>
                        </CircleMenuItem>
                        
                        <CircleMenuItem onClick={increaseFont}>
                            <TextIncreaseIcon color='primary' fontSize='small'/>
                        </CircleMenuItem>

                        <CircleMenuItem onClick={decreaseFont}>
                            <TextDecreaseIcon color='primary' fontSize='small'/>
                        </CircleMenuItem>

                        <CircleMenuItem onClick={handleAlign}>
                        {align==='center' && (
                            <FormatAlignCenterIcon color='primary' fontSize='small'/>)
                        }
                        {align==='left' && (
                            <FormatAlignLeftIcon color='primary' fontSize='small'/>)
                        }
                        {align==='right' && (
                            <FormatAlignRightIcon color='primary' fontSize='small'/>)
                        }
                        </CircleMenuItem>

                    </CircleMenu>
                </ThemeProvider>
                    {abrirModalImagen && (
                        <ModalImagen
                            id={id}
                            setMostrarImagen={setMostrarImagen}
                            mostrarImagen={mostrarImagen}
                            nodos={nodos}
                            setNodos={setNodos}
                            abrirModalImagen={abrirModalImagen}
                            handleCloseModalImage={handleCloseModalImage}
                        />
                    )}
                </Html>
            </Group>

            { abrirModalColor && (
                <Group 
                x={x+width+13} 
                y={y-120} 
                >
                    <Html
                        divProps={{ style: { opacity: 1 } }}
                        >
                        <SeleccionarColor
                            id={id}
                            setAbrirModalColor={setAbrirModalColor}
                            abrirModalColor={abrirModalColor}
                            handleCloseColor={handleCloseColor}
                            setNodos={setNodos}
                            nodos={nodos}
                            isSelected={isSelected}
                            fill={fill}
                        />
                    </Html>
                </Group>
            )}
            { abrirModalTexto && (
                <Group 
                    x={x+width+53} 
                    y={y-50} 
                >
                    <Html
                        divProps={{ style: { opacity: 1 } }}
                        >
                        <CambiarColorTexto
                            id={id}
                            setAbrirModalTexto={setAbrirModalTexto}
                            abrirModalTexto={abrirModalTexto}
                            handleCloseColor={handleCloseColor}
                            setNodos={setNodos}
                            nodos={nodos}
                            isSelected={isSelected}
                            textFill={textFill}
                        />
                    </Html>
                </Group>
            )}
        </>
    )
}

export default PanelHerramientas